import React, { Component } from "react";

export default class TextInput extends Component {
  handleChangeInput(event, props) {
    if (!props.onChange) return;
    props.onChange(event.target.value, props.inputKey);
  }

  render() {
    return (
      <div className={`col-md-${this.props.widthRatio}`}>
        <label>{this.props.label}</label>
        <input
          className="form-control"
          type={this.props.isNumber ? "number" : "text"}
          value={this.props.value}
          onChange={(event) => this.handleChangeInput(event, this.props)}
          disabled={!this.props.onChange}
        />
      </div>
    );
  }
}
